const CodeBlockInline = ({ children }: { children: string }) => {
    return <span className="rounded-md border border-gray-300 bg-gray-50 p-0.5 font-mono text-xs">{children}</span>;
};
export default CodeBlockInline;
